

export class UserSelectByIdOutputDataApplicationModuleData implements IUserSelectByIdOutputDataApplicationModuleData {
    /** The auto-generated id of the application module */
    application_module_id!: number;

    constructor(data?: IUserSelectByIdOutputDataApplicationModuleData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application_module_id = _data["application_module_id"];
        }
    }

    static fromJS(data: any): UserSelectByIdOutputDataApplicationModuleData {
        data = typeof data === 'object' ? data : {};
        let result = new UserSelectByIdOutputDataApplicationModuleData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application_module_id"] = this.application_module_id;
        return data; 
    }
}

export interface IUserSelectByIdOutputDataApplicationModuleData {
    /** The auto-generated id of the application module */
    application_module_id: number;
}

